// extracted by mini-css-extract-plugin
export default {"button":"fQQxh","primaryButton":"jXhi4","disabledButton":"rQZ2S"};